import React from 'react';
import { useAppState } from 'src/lib/hooks';
import { Col, Nav, Row } from 'straightline-ui';

import NavTab from '../NavTab';

export default function SettingsHeader({ activeTab, children }) {
  const {
    state: { shipper }
  } = useAppState();
  return (
    <Row>
      <Col>
        <div className="header pt-md-2">
          <div className="header-body">
            <Row className="align-items-center">
              <Col>
                <h6 className="header-pretitle">Settings</h6>
                <h1 className="header-title">{shipper.name}</h1>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col>
                <Nav tabs className="nav-overflow header-tabs">
                  <NavTab to="/settings" activeTab={activeTab} tab="shipper">
                    My Business
                  </NavTab>
                  <NavTab
                    to="/settings/profile"
                    activeTab={activeTab}
                    tab="profile"
                  >
                    My Profile
                  </NavTab>
                  <NavTab
                    to="/settings/billing"
                    activeTab={activeTab}
                    tab="billing"
                  >
                    Billing
                  </NavTab>
                  <NavTab
                    to="/settings/users"
                    activeTab={activeTab}
                    tab="users"
                  >
                    My Team
                  </NavTab>
                </Nav>
              </Col>
              {children && <Col>{children}</Col>}
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
}
